import React from 'react';
import {connect} from "react-redux";

class InputSearchFilter extends React.Component {
    constructor(props) {
        super(props);
    }
    setQuery = (value) => {
        this.props.sendQuery(value)
    }
    render(){
        return(
            <div className="search-input">
                <input type="text" placeholder="Find…" onChange={event => this.setQuery(event.target.value)}/>
            </div>
        )
    }
}
export default InputSearchFilter;